import React from 'react';
import { View, Text, StyleSheet} from '../Primitives'

const boxStyle = StyleSheet.create({
    
    box:{
        display:'flex',

        border: '1pt solid #000',
        marginLeft:30,
        marginRight:30,
        marginBottom:15,
        height:'auto'

    },
    charterRequestParent:{
        display:'flex',

        marginLeft:30,
        marginRight:30,
        marginBottom:15,
        height:'auto'

    },
    rowContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex:1,
        marginBottom:15,
    },
    colContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex:1
    },
    flexBox:{
        display:'flex',
        flex:1,
        marginBottom:5
    },
   
    leftText:{
        fontSize:12,
        fontFamily:'Helvetica-Bold'
    },
    rightText:{
        fontSize:12,
    },
    jbNum:{
        fontSize:13,
    },
    statusText: {
        fontSize: 11,
    }

})

const CharterDetail = ({charter}) =>{
    return <View style={boxStyle.charterRequestParent}>
        <View style={boxStyle.rowContainer}>
            <View style={boxStyle.colContainer}>
                <Text style={boxStyle.leftText}>Aircraft Preference:</Text>
                <Text style={boxStyle.jbNum}>{charter.preferredAircraft?charter.preferredAircraft:'No Preference'}</Text>
            </View>
            <View style={boxStyle.colContainer}>
                <Text style={boxStyle.leftText}>Dangerous Goods</Text>      
                <Text style={boxStyle.statusText}>{charter.dangerousGoods}</Text>
            </View>
            <View style={boxStyle.colContainer}>
                <Text style={boxStyle.leftText}>Charter Type</Text>      
                <Text style={boxStyle.statusText}>{charter.charterType}</Text>
            </View>
        </View>
    
        <View style={boxStyle.rowContainer}>
            <View style={boxStyle.colContainer}>
                <Text style={boxStyle.leftText}>Urgent:</Text>
                <Text style={boxStyle.rightText}>{charter.urgent?'Yes':'No'}</Text>
            </View>       
            <View style={boxStyle.colContainer}>
                <Text style={boxStyle.leftText}>Bidding Time Span:</Text>
                <Text style={boxStyle.rightText}>{charter.biddingTimeSpanHours}</Text>
            </View>
            <View style={boxStyle.colContainer}>
                <Text style={boxStyle.leftText}>Charter SubType:</Text>
                <Text style={boxStyle.rightText}>{charter.charterSubType}</Text>
            </View>
        </View>
    </View>
  
}

export default CharterDetail;